
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elektriker-tjenester/[slug]",
      function () {
        return require("private-next-pages/elektriker-tjenester/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elektriker-tjenester/[slug]"])
      });
    }
  